import { render, staticRenderFns } from "./aftersales.vue?vue&type=template&id=1df8586f&scoped=true"
import script from "./aftersales.vue?vue&type=script&lang=ts"
export * from "./aftersales.vue?vue&type=script&lang=ts"
import style0 from "./aftersales.vue?vue&type=style&index=0&id=1df8586f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df8586f",
  null
  
)

export default component.exports